import React from "react";
import {ButtonGroup, ButtonGroupButton, Icon} from "peggirkit";
import {FunnelIcon, ShoppingBagIcon, TruckIcon} from "@heroicons/react/20/solid";
import {SetStateFn} from "@/utils/SetStateUtils";
import {FormattedMessage} from "react-intl";


export type FulfillmentFilter = "DELIVERY" | "TAKEAWAY" | "ALL";

type Props = {
    fulfillmentFilter: FulfillmentFilter,
    setFulfillmentFilter: SetStateFn<FulfillmentFilter>,
};

const FulfillmentFilterButtons = ({fulfillmentFilter, setFulfillmentFilter}: Props) => {
    return (
        <ButtonGroup variant={"outline"}>
            <ButtonGroupButton
                selected={fulfillmentFilter === "ALL"}
                iconBefore={<Icon icon={FunnelIcon}/>}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: () => setFulfillmentFilter("ALL")
                    },
                }}
            >
                <FormattedMessage id={"all"}/>
            </ButtonGroupButton>
            <ButtonGroupButton
                selected={fulfillmentFilter === "TAKEAWAY"}
                iconBefore={<Icon icon={ShoppingBagIcon}/>}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: () => setFulfillmentFilter("TAKEAWAY")
                    },
                }}
            >
                <FormattedMessage id={"takeaway"}/>
            </ButtonGroupButton>
            <ButtonGroupButton
                selected={fulfillmentFilter === "DELIVERY"}
                iconBefore={<Icon icon={TruckIcon}/>}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: () => setFulfillmentFilter("DELIVERY")
                    },
                }}
            >
                <FormattedMessage id={"delivery"}/>
            </ButtonGroupButton>
        </ButtonGroup>
    );
};

export default FulfillmentFilterButtons;